import type { UserShape } from '../ownership-models';

export const getUserAvatarSrc = (user: UserShape): string | undefined => {
	return user.isAnonymous || !user.avatarUrl ? undefined : user.avatarUrl;
};
